import { gql } from "@apollo/client";

export const GET_PERMISO_BLOQUEO = gql`
query GetPermisoBloqueoClienteRequisito {
    permisoBloqueoClienteRequisito
}`;